import { ErrosAws } from 'constants/ErrosAws';
import { TErrorAws } from 'types/TErrorAws';

export const isErrorAws = (error: unknown) =>
  ErrosAws.find((e) => e.name === (error as TErrorAws)?.code);
